import { LoggerFactory } from './LoggerFactory.js';
export class LibraryLoggerFactory {
    constructor(name) {
        this.childLoggers = [];
        this.loggerName = name;
        this.logger = LoggerFactory.create(name);
    }
    /**
     * Set the logLevel for all logs in this library
     */
    setLogLevel(level, loggerName) {
        // eslint-disable-next-line no-param-reassign
        this.logger.level = level;
        for (const logger of this.childLoggers) {
            if (loggerName) {
                if (logger.bindings() && logger.bindings().name === loggerName) {
                    logger.level = level;
                }
            }
            else {
                logger.level = level;
            }
        }
    }
    /**
     * Used by consumer of the library to set bindings (metadata) that should be included with the logs.
     */
    setBindings(bindings) {
        this.logger.setBindings(bindings);
        // Loop through any children that have been created and update their bindings
        for (const logger of this.childLoggers) {
            logger.setBindings({
                ...bindings,
                name: logger.bindings?.name
            });
        }
    }
    /**
     * Create a new logger with the provided name.
     *
     * @returns
     */
    create(name) {
        const child = this.logger.child({ name: `${this.loggerName}.${name}` });
        this.childLoggers.push(child);
        return child;
    }
}
/**
 * Function to generate a class extending LibraryLoggerFactory
 * @param name Name of the root logger
 * @returns A LoggerFactory class that extends LibraryLoggerFactory
 */
export function createLoggerFactory(name) {
    var _a;
    return _a = class GeneratedLoggerFactory extends LibraryLoggerFactory {
            constructor() {
                super(name);
            }
            static create(childName) {
                return GeneratedLoggerFactory._instance.create(childName);
            }
            static setLogLevel(level, loggerName) {
                return GeneratedLoggerFactory._instance.setLogLevel(level, loggerName);
            }
            static setBindings(bindings) {
                return GeneratedLoggerFactory._instance.setBindings(bindings);
            }
        },
        _a._instance = new _a(),
        _a;
}
//# sourceMappingURL=LibraryLoggerFactory.js.map